export default "__VITE_ASSET__Cgd8jVd7__"